import React from "react";
import "styles/dashboardAdmin/loading.css";

const Loaging = () => {
  return <div className="load"></div>;
};

export default Loaging;
